import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'bootstrap';

export default function Instruksi({ isOpen, close, content, countdown, ...props }) {
    const modalRef = useRef(null);
    const [read, setRead] = useState(false);
    
    useEffect(() => {
        if (!modalRef.current) return;

        let modalInstance = Modal.getOrCreateInstance(modalRef.current, {
            backdrop: 'static',
            keyboard: false
        });

        const handleHidden = () => {
            close();
        };

        const modalEl = modalRef.current;
        modalEl.addEventListener('hidden.bs.modal', handleHidden);

        if (isOpen) {
            modalInstance.show();
        } else {
            modalInstance.hide();
            setRead(false);
        }

        return () => {
            modalEl.removeEventListener('hidden.bs.modal', handleHidden);
        };
    }, [isOpen]);

    return (
        <div className="modal modal-fade fade" tabIndex="-1" role="dialog" ref={modalRef}>
            <div className="modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Instruksi</h5>
                        <div className='d-flex align-items-center'>
                            <div className="me-4">
                                <p className="fs-2 fw-bold card-text">{countdown.time.hours || '00'}:{countdown.time.minutes || '00'}:{countdown.time.seconds || '00'}</p>
                            </div>
                            {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" disabled={!read}></button> */}
                        </div>
                    </div>
                    <div className="modal-body">
                        <div dangerouslySetInnerHTML={{ __html: content }}></div>
                    </div>
                    <div className="modal-footer w-100 justify-content-between">
                        <div className="form-check">
                            <input onChange={() => setRead(!read)} className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked={read} />
                            <label className="form-check-label" htmlFor="flexCheckChecked">
                                Saya telah membaca instruksi dengan seksama
                            </label>
                        </div>
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={!read}>Oke</button>
                    </div>
                </div>
            </div>
        </div>
    )
}